import { Match, MediaSource, MatchEvent, CodeEventGroup, Button } from '../../models';
import { DartfishNotebookProperties } from './DartfishNotebookProperties';
import { DartfishNotebookParser } from './DartfishNotebookParser';
import { IFileImporter } from '../IFileConverter';
import * as functions from '../../common/functions';

export class DartfishFileConverter implements IFileImporter {
  public name = 'Dartfish EasyTag';

  convert(input: string): Match {
    const dartfishParser = new DartfishNotebookParser();
    const props = dartfishParser.parse(input);

    const match = {
      competitionName: '',
      awayTeam: '',
      homeTeam: '',
      grade: '',
      year: new Date().getFullYear(),
      matchName: '',
      matchDate: new Date().toDateString(),
      roundNumber: 0,
      venue: '',
      userId: '',
      media: {} as MediaSource,
      identifier: '',
      buttonSetId: null,
      isPublished: false,
      isCurrentPublished: false,
      events: []
    } as Match;

    const buttons = DartfishFileConverter.processButtons(props);
    const events = DartfishFileConverter.processCodedEvents(props, buttons);

    match.events = events;
    return match;
  }

  static processButtons(props: DartfishNotebookProperties[]): Button[] {
    const buttons = [] as Button[];

    console.info('[DartfishConverter] ProcessButtons: ', props);

    if (props !== undefined && props !== null) {
      for (let i = 0; i < props.length; i++) {
        const item = props[i];
        const existingButton = buttons.filter(e => e.eventType === item.Name);

        if (item && existingButton.length === 0) {
          buttons.push({
            identifier: item.Name,
            name: item.Name,
            type: item.Name,
            eventType: item.Name,
            color: 'blue',
            leadSeconds: 5,
            lagSeconds: 5
          } as Button);
        }
      }
    }

    return buttons.filter(e => e.name && e.name.trim().length > 0 && e.name !== 'Empty');
  }

  static processCodedEvents(
    props: DartfishNotebookProperties[],
    buttons: Button[]
  ): CodeEventGroup[] {
    const codedEventTypes = [] as CodeEventGroup[];

    console.info('[DartfishConverter] ProcessCodedEvents: ', props);

    if (props) {
      for (let i = 0; i < props.length; i++) {
        const codedEvent = props[i];

        const identifier = functions.getTimestamp();
        const code = codedEvent.Name;
        const start = codedEvent.Position;
        const end = codedEvent.Position + codedEvent.Duration;

        let item = codedEventTypes.find(e => e.eventType === code);
        const btns = buttons.filter(b => b.name === code);

        if (btns !== undefined && btns[0] !== undefined) {
          const btn = btns[0];

          if (item === null || item === undefined) {
            item = {
              eventType: code,
              events: []
            } as CodeEventGroup;

            codedEventTypes.push(item);
          }

          item.events.push({
            identifier,
            eventType: item.eventType,
            color: btn.color,
            leadSeconds: 5,
            lagSeconds: 5,
            seconds: Math.max(codedEvent.Position / 1000, 0)
          } as MatchEvent);

          item.events = item.events.sort((a, b) => a.seconds - b.seconds);
        }
      }
    }

    return codedEventTypes.filter(e => e !== undefined);
  }
}
